
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../base/Button';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [aboutDropdown, setAboutDropdown] = useState(false);
  const [projectsDropdown, setProjectsDropdown] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navHeight = isScrolled ? 'h-16' : 'h-20';

  return (
    <nav className={`fixed top-0 left-0 right-0 bg-white shadow-md z-50 transition-all duration-300 ${navHeight}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex justify-between items-center h-full">
          {/* Logo */}
          <Link to="/" className="flex items-center h-full">
            <img 
              src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/2c79e66b2db86b6c99b02e168318d8a7.png" 
              alt="Birsöz İnşaat" 
              className="h-10 w-auto"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center h-full space-x-8">
            <Link 
              to="/" 
              className={`flex items-center h-full text-sm font-medium transition-colors duration-200 ${
                location.pathname === '/' ? 'text-[#0e3851]' : 'text-gray-600 hover:text-[#0e3851]'
              }`}
            >
              Anasayfa
            </Link>
            
            {/* Hakkımızda Dropdown */}
            <div 
              className="relative flex items-center h-full"
              onMouseEnter={() => setAboutDropdown(true)}
              onMouseLeave={() => setAboutDropdown(false)}
            >
              <button className="flex items-center h-full text-sm font-medium text-gray-600 hover:text-[#0e3851] transition-colors duration-200">
                Hakkımızda
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              {aboutDropdown && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-2xl shadow-xl py-2 border">
                  <Link to="/hakkimizda" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#0e3851]">
                    Kurumsal Profil
                  </Link>
                  <Link to="/vizyon-misyon" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#0e3851]">
                    Vizyon & Misyon
                  </Link>
                  <Link to="/belgeler" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#0e3851]">
                    Belgeler & Sertifikalar
                  </Link>
                  <Link to="/cozum-ortaklari" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#0e3851]">
                    Çözüm Ortaklarımız
                  </Link>
                </div>
              )}
            </div>

            {/* Projeler Dropdown */}
            <div 
              className="relative flex items-center h-full"
              onMouseEnter={() => setProjectsDropdown(true)}
              onMouseLeave={() => setProjectsDropdown(false)}
            >
              <button className="flex items-center h-full text-sm font-medium text-gray-600 hover:text-[#0e3851] transition-colors duration-200">
                Projeler
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              {projectsDropdown && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-2xl shadow-xl py-2 border">
                  <Link to="/projeler" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#0e3851]">
                    Tüm Projeler
                  </Link>
                  <Link to="/kiraya-sunulan" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#0e3851]">
                    Kiraya Sunulan
                  </Link>
                </div>
              )}
            </div>

            <Link 
              to="/arsa-degerlendirme" 
              className="flex items-center h-full text-sm font-medium text-gray-600 hover:text-[#0e3851] transition-colors duration-200"
            >
              Arsanızı Değerlendirelim
            </Link>
            
            <Link 
              to="/blog" 
              className="flex items-center h-full text-sm font-medium text-gray-600 hover:text-[#0e3851] transition-colors duration-200"
            >
              Blog
            </Link>

            <div className="flex items-center h-full">
              <Button size="sm">
                <i className="ri-phone-line mr-2"></i>
                İletişim
              </Button>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 flex items-center justify-center"
            onClick={() => setIsOpen(!isOpen)}
          >
            <i className={`text-xl text-[#0e3851] ${isOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden fixed inset-0 top-20 bg-white z-40">
          <div className="px-4 py-6 space-y-4">
            <Link to="/" className="block text-base font-medium text-gray-700 py-2">Anasayfa</Link>
            <div className="space-y-2">
              <div className="text-base font-medium text-[#0e3851] py-2">Hakkımızda</div>
              <Link to="/hakkimizda" className="block text-sm text-gray-600 py-1 pl-4">Kurumsal Profil</Link>
              <Link to="/vizyon-misyon" className="block text-sm text-gray-600 py-1 pl-4">Vizyon & Misyon</Link>
              <Link to="/belgeler" className="block text-sm text-gray-600 py-1 pl-4">Belgeler & Sertifikalar</Link>
              <Link to="/cozum-ortaklari" className="block text-sm text-gray-600 py-1 pl-4">Çözüm Ortaklarımız</Link>
            </div>
            <div className="space-y-2">
              <div className="text-base font-medium text-[#0e3851] py-2">Projeler</div>
              <Link to="/projeler" className="block text-sm text-gray-600 py-1 pl-4">Tüm Projeler</Link>
              <Link to="/kiraya-sunulan" className="block text-sm text-gray-600 py-1 pl-4">Kiraya Sunulan</Link>
            </div>
            <Link to="/arsa-degerlendirme" className="block text-base font-medium text-gray-700 py-2">Arsanızı Değerlendirelim</Link>
            <Link to="/blog" className="block text-base font-medium text-gray-700 py-2">Blog</Link>
            <Link to="/iletisim" className="block text-base font-medium text-gray-700 py-2">İletişim</Link>
          </div>
        </div>
      )}
    </nav>
  );
};
